import React, { useEffect } from 'react';
import UcatLandingPage from '../../features/specialty/ucat';

export default function UcatLandingRoute() {
  useEffect(() => {
    document.title = "UCAT Prep 2026/2027 — Medical Schools Admissions Simulator | Pathbuddy";
    window.scrollTo(0, 0);
  }, []);

  return <UcatLandingPage />;
}
